'use strict';

/**
 * @ngdoc function
 * @name bgAngularApp.controller:MainCtrl
 * @description
 * # MainCtrl
 * Controller of the bgAngularApp
 */
angular.module('bgAngularApp')
  .controller('TopicCtrl', ['$rootScope', '$scope', '$sce', 'badgame', '$location', '$anchorScroll', '$routeParams', 'toastr', function ($rootScope, $scope, $sce, badgame, $location, $anchorScroll, $routeParams, toastr) {
    // Disable anchor scroll when pulling in new content
    $scope.disableAnchor = false;

    // Init to 40, but use server settings after loading a page
    $scope.postsPerPage = 40;
    $scope.offsetOverride = undefined;
    $scope.breadcrumbs = [];
    $scope.pageLimitReached = false;
    $scope.posts = [];

    function getOffset() {
      return $scope.offsetOverride ? $routeParams.offset : ($scope.currentPage - 1) * $scope.postsPerPage;
    }

    $scope.trustIt = function(data) {
      return $sce.trustAsHtml(data);
    };

    // Refresh the posts for the scope using current parameters
    $scope.refreshPosts = function() {
      var offset = getOffset();

      // Reset override
      if($scope.offsetOverride) {
        $scope.offsetOverride = undefined;
      }

      var postGetter = $scope.searchMode ? badgame.getSearchResults : badgame.getPosts;

      postGetter(offset).then(function(data) {
        badgame.newPostMode = false;
        $rootScope.Page.setTitle(data.crumbs.slice(-1)[0].name);
        $scope.breadcrumbs = data.crumbs.slice(2);
        $scope.can_reply = data.can_reply ? true : false;
        $scope.uplink = $scope.breadcrumbs[0].url;
        $scope.posts = data.messages;
        $scope.currentPage = data.page_info.current_page;
        $scope.postsPerPage = data.page_info.items_per_page;
        $scope.totalItems = data.page_info.total_items;
        $scope.replyUrl = data.reply_url;

        if($scope.posts.length >= $scope.postsPerPage) {
          $scope.pageLimitReached = true;
        }
      });
    };

    $scope.$on('tweetsComplete', function(event) {
      if(!$scope.disableAnchor) {
        $anchorScroll();
      }
    });

    $scope.handleEdit = function(element) {
      badgame.postUrl = element.edit_url;
      $location.path('/post/msg' + element.id);
    }

    $scope.handleQuote = function(element) {
      badgame.postUrl = element.quote_url;

      if(badgame.postUrl.indexOf("sesc") == -1) {
        badgame.postUrl += "&sesc=" + badgame.session;
      }

      $location.path('/post');
    };

    $scope.handleReplyClick = function() {
      badgame.postUrl = $scope.replyUrl;
      $location.path('/post');
    };

    $scope.decideReply = function() {
      if ($rootScope.enableQuickPost) {
        $scope.triggerToastPost();
      } else {
        $scope.handleReplyClick();
      }
    };


    // Handle page changes
    $scope.pageChanged = function() {
      if($scope.searchMode) {
        $location.path('/searchresults/' + getOffset());
      } else {
        $location.path('/topic/' + $routeParams.topicId + '/' + getOffset());
      }

      $location.hash('top');
    };

    $scope.toastAuthor = function(post) {
      var info = "Registered on " + post.registered + "<br>" + "Post count: " + post.posts;

      if(post.nickname != '') {
        info = '<i>' + post.nickname + '</i><br/>' + info;
      }

      toastr.clear();
      toastr.info(info, post.username);
    };

    $scope.triggerToastPost = function() {
      $rootScope.$emit('toast-post-trigger');
    };

    if($routeParams.offset) {
      $scope.offsetOverride = true;
    }

    if($routeParams.topicId) {
      badgame.currentTopic = $routeParams.topicId;
    }

    $scope.firehoseMode = $location.path().indexOf('firehose') > -1;
    $scope.searchMode = $location.path().indexOf('searchresults') > -1;

    // Redirect to search page if empty query specified
    if($scope.searchMode && !badgame.searchParams.search) {
      $location.path('/search');
    }

    // Load the initial set of posts
    if(!$scope.firehoseMode) {
      $scope.refreshPosts();
    }
}]);
